import { useContext } from "react";
import { ResetPasswordActionContext } from "./ResetPasswordActionContext";

function usePrepareResetPassword() {
  const {setEmail, setShowModal} = useContext(ResetPasswordActionContext);
  return (email: string) => {
    setEmail(email);
    setShowModal(true)
  }
}

export default usePrepareResetPassword;